var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.373 17.68a7.959 7.959 0 01-6.706 3.653c-4.414 0-8-3.586-8-8 0-4.413 3.586-8 8-8 1.973 0 3.773.707 5.16 1.894a5.205 5.205 0 00.013 1.76l1.533 8.693z",
    stroke: "url(#otc_svg__mobile-paint0_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.907 15l-13.96-3.733",
    stroke: "url(#otc_svg__mobile-paint1_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.88 29.253a5.385 5.385 0 01-6.24-4.36l-2.8-15.906a5.385 5.385 0 014.36-6.24 5.385 5.385 0 016.24 4.36l2.8 15.906c.533 2.934-1.427 5.72-4.36 6.24z",
    stroke: "url(#otc_svg__mobile-paint2_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.253 16.933l10.6-1.866",
    stroke: "url(#otc_svg__mobile-paint3_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "otc_svg__mobile-paint0_linear",
    x1: 2.667,
    y1: 21.333,
    x2: 20.621,
    y2: 15.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "otc_svg__mobile-paint1_linear",
    x1: 2.947,
    y1: 15,
    x2: 10.091,
    y2: 5.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "otc_svg__mobile-paint2_linear",
    x1: 15.757,
    y1: 29.337,
    x2: 33.416,
    y2: 26.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "otc_svg__mobile-paint3_linear",
    x1: 17.253,
    y1: 16.933,
    x2: 20.254,
    y2: 11.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })))));
}

export default SvgOtc;